export const productApplicationFormData = {
    formID: 'product_application',
    searchFixedKeys: [
        { key: 'market_code.code', formKey: 'market', isCode: true, autoSuggestKey: 'market_code' }//,
        // { key: 'workflowstate.code', value: 'published', isCode: true, autoSuggestKey: 'workflowstate', autoSuggestValue: 'published' }
    ],
    lang: { formKey: 'productApplicationLang' },
    autoSuggestMetaData: {
        display_name: {
            completionFields: ["completion_display_name"],
            fields: [
                "display_name",
                "sap_product_id",
                "o_id"
            ]
        },
        sap_product_id: {
            completionFields: ["completion_sap_product_id"],
            fields: [
                "display_name",
                "sap_product_id",
                "o_id"
            ]
        }
    },
    displayName: { // used to render mainName ( subName ) formatted label
        mainName: 'display_name',
        subName: 'cms_id'
    }
}

export const productGroupFormData = {
    formID: 'product_group',
    lang: { value: 'EN' },
    searchFixedKeys: [
        { key: 'market_code.code', formKey: 'market', isCode: true, autoSuggestKey: 'market_code' }
        // { key: 'workflowstate.code', value: 'published', isCode: true, autoSuggestKey: 'workflowstate', autoSuggestValue: 'published' }
    ],
    autoSuggestMetaData: {
        sap_product_id: {
            completionFields: ["completion_sap_product_id"],
            fields: [
                "display_name",
                "sap_product_id",
                "o_id"
            ]
        },
        display_name: {
            completionFields: ["completion_display_name"],
            fields: [
                "display_name",
                "sap_product_id",
                "o_id"
            ]
        }
    },
    displayName: {
        mainName: 'display_name',
        subName: 'sap_product_id'
    }
}

export const productFormData = {
    formID: 'product'
}

export const PROD_APPLICATIONS = 'product_application';
export const PROD_GROUP = 'product_group';
export const PRODUCT = 'product'
// header for datatable in product page
export const formMetaData = {
    [PROD_APPLICATIONS]:
    {
        "uniqueID": "cms_id",
        "searchResultFieldList": [
            { "dataField": "cms_id", "text": "CMS_ID", headerAttrs: { className: 'w-10' } },
            { "dataField": "display_name", "text": "Display_Name", headerAttrs: { className: 'w-75' } },
            { "dataField": "market_code", "text": "Market_Code" }],
        "searchOptions": [
            {
                value: "barcode",
                text: "Barcode",
                fieldtype: "input",
                options: []
            },
            {
                "value": "display_name",
                "text": "Display_Name",
                "fieldtype": "autosuggest",
                "options": []
            },
            {
                value: "sap_product_id",
                text: "SAP_Product_ID",
                fieldtype: "autosuggest",
                options: []
            }],
        "moreInfo": productApplicationFormData
    },
    [PROD_GROUP]:
    {
        "uniqueID": "sap_product_id",
        "searchResultFieldList": [
            { "dataField": "sap_product_id", "text": "SAP_Product_ID", headerAttrs: { className: 'w-20' } },
            { "dataField": "cms_id", "text": "CMS_ID", headerAttrs: { className: 'w-10' } },
            { "dataField": "display_name", "text": "Display_Name", headerAttrs: { className: 'w-55' } },
            { "dataField": "market_code", "text": "Market_Code", headerAttrs: { className: 'w-20' } }],
        "searchOptions": [
            {
                value: "barcode",
                text: "Barcode",
                fieldtype: "input",
                options: []
            },
            {
                "value": "display_name",
                "text": "Display_Name",
                "fieldtype": "autosuggest",
                "options": []
            },
            {
                "value": "sap_product_id",
                "text": "SAP_Product_ID",
                "fieldtype": "autosuggest",
                "options": []
            }
        ],
        "moreInfo": productGroupFormData
    }
};
export const P_ITEMS_LIMIT = 10;
